/**
 * Реализация отображение списка отзывов (translate-website)
 * $TODO - на текущей итерации, заглушка (которая что-то там показывает)
 */

import React from 'react';
import {
    Datagrid,
    DateField,
    List,
    TextField,
    Show,
    RaRecord,
    TextInput} from 'react-admin';
// import DateRanges from 'components/date-range/ra-date-range';
import PropertiesPanel from './properties-panel';

const ShowDetail: React.FC = (props: any) => {
  return (
    <Show
      /* disable the app title change when shown */
      {...props}
      title=" ">
        <PropertiesPanel {...props}/>
    </Show>);
}

const getFilters = (permissions: string): React.ReactElement[] => {
  const retList: React.ReactElement[] = 
  [
    <TextInput source="uuid" label='UUID'/>,
    <TextInput source="original_language" label='Original Language'/>,
    <TextInput source="translation_language" label='Translation Language'/>,
    <TextInput source="translation_is_correct" label='Is correct'/>,
    // <DateRanges source="created_at" label = 'Create At'/>,
    // <DateRanges source="modified_at" label = 'Modified At'/>
  ];
  return retList;
}

type RaProps = Omit<RaRecord, 'id'>;

interface Props extends RaProps {
  permission: string;
}

const TranslateFeedbacksList: React.FC<Props> =  ({ permissions, ...props }) => {
  return <List
                title="Feedbacks"
                perPage={25}
                sort={{ field: 'modified_at', order: 'DESC' }}
                filters={getFilters(permissions)}
                bulkActionButtons={false}
                {...props}
                >
            <Datagrid 
                  bulkActionButtons={false}
                  expand={<ShowDetail />}
                  expandSingle>
                <TextField source="uuid" label='UUID'/>
                <TextField source="original_language" label='Original Language'/>
                <TextField source="translation_language" label='Translation Language'/>
                <TextField source="translation_suggestion" label='Suggestion'/>
                <TextField source="translation_is_correct" label='Is correct'/>
                <DateField source="created_at" label='Create At'/>
                <DateField source="modified_at" label='Modified At'/>
            </Datagrid>
          </List>
}

export default TranslateFeedbacksList;
